import axios from "axios"
import { getConfig } from "../config/config";


export async function consumoPeriodoBuscaEmpresa(token: string, empresaID : string, dateStart: string, dateEnd: string) : Promise<any>{

  try 
  {
    const response = await axios.get(
      getConfig().API_URL + "/consumoPeriodoBuscaEmpresa/"+ empresaID + "/" + dateStart + "/" + dateEnd ,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return {success: true, message:'', result: response.data};

  } catch (error: any) 
  {
    if(error)
      return {success: false, message: error.message};
  }

  return {success:false, message: 'Erro desconhecido. Tente novamente mais tarde.', result: ''};

}